var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxUnauthorizedAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83398 0C10.3637 0.000126536 12.4168 2.05327 12.417 4.58301V7H13.333C14.3458 7 15.1668 7.82027 15.167 8.83301V17.417C15.1669 18.4297 14.3467 19.2499 13.334 19.25H2.33398C1.32115 19.25 0.50014 18.4298 0.5 17.417V8.83301C0.500211 7.82043 1.32044 7.00026 2.33301 7H10.6748L10.6758 4.58301C10.6756 3.01576 9.40125 1.74231 7.83398 1.74219C6.26661 1.74219 4.9924 3.01569 4.99219 4.58301V5H3.25V4.58301C3.25021 2.05319 5.30411 0 7.83398 0ZM8 11.8574L5.14258 9L4 10.1426L6.85742 13L4.00195 15.8555L5.14453 16.998L8 14.1426L10.8555 16.998L11.998 15.8555L9.14258 13L12 10.1426L10.8574 9L8 11.8574Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxUnauthorizedAccess);
export default __webpack_public_path__ + "static/media/BoxUnauthorizedAccess.61f82ec77dea4ad1bc6f78a524c73c9a.svg";
export { ForwardRef as ReactComponent };